/**
 * Ethos Shoes - Slider Auto-Play
 * Auto-rotates slider-component elements with data-autoplay attribute
 * Uses scrollBy for maximum browser compatibility
 */
(function () {
  function smoothScrollBy(el, totalDistance, duration) {
    if (Math.abs(totalDistance) < 1) return;
    var scrolled = 0;
    var steps = Math.ceil(duration / 16);
    var currentStep = 0;
    var animInterval = setInterval(function () {
      currentStep++;
      var progress = currentStep / steps;
      if (progress >= 1) {
        var remaining = totalDistance - scrolled;
        if (Math.abs(remaining) > 0) {
          el.scrollBy({ left: remaining, behavior: 'instant' });
        }
        clearInterval(animInterval);
        return;
      }
      // easeInOutCubic
      var ease = progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2;
      var targetScrolled = totalDistance * ease;
      var delta = targetScrolled - scrolled;
      if (Math.abs(delta) >= 1) {
        el.scrollBy({ left: Math.round(delta), behavior: 'instant' });
        scrolled += Math.round(delta);
      }
    }, 16);
  }

  function initAutoplay() {
    document.querySelectorAll('slider-component[data-autoplay]').forEach(function (slider) {
      var speed = parseInt(slider.dataset.autoplaySpeed) || 4000;
      var sliderEl = slider.querySelector('.slider');
      if (!sliderEl) return;

      var slides = sliderEl.querySelectorAll('.slider__slide');
      if (slides.length <= 1) return;

      var interval = null;
      var paused = false;

      function getSlideWidth() {
        var firstSlide = slides[0];
        if (!firstSlide) return 300;
        var gap = parseFloat(getComputedStyle(sliderEl).columnGap) || 0;
        return firstSlide.offsetWidth + gap;
      }

      function autoSlide() {
        if (paused) return;
        var maxScroll = sliderEl.scrollWidth - sliderEl.clientWidth;
        if (sliderEl.scrollLeft >= maxScroll - 20) {
          // Reset to beginning
          sliderEl.scrollBy({ left: -99999, behavior: 'instant' });
        } else {
          smoothScrollBy(sliderEl, getSlideWidth(), 600);
        }
      }

      function play() {
        paused = false;
        if (interval) clearInterval(interval);
        interval = setInterval(autoSlide, speed);
      }

      function pause() {
        paused = true;
        if (interval) {
          clearInterval(interval);
          interval = null;
        }
      }

      slider.addEventListener('mouseenter', pause);
      slider.addEventListener('mouseleave', play);
      slider.addEventListener('focusin', pause);
      slider.addEventListener('focusout', play);
      slider.addEventListener('touchstart', pause, { passive: true });
      slider.addEventListener('touchend', function () {
        setTimeout(play, 3000);
      });

      play();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(initAutoplay, 1500);
    });
  } else {
    setTimeout(initAutoplay, 1500);
  }
})();
